<ion-content class="ion-padding">

  <h1>
    {{ "modal.verify-pin.title" | translate }}
    <ion-button class="icon-only" fill="clear" (click)="dismiss()">
      <ion-icon name="close-outline" color="primary"></ion-icon>
    </ion-button>
  </h1>

  <app-digit-input #input="ngModel" [(ngModel)]="myPin" (onEnterKey)="confirm()"></app-digit-input>

  <ion-button class="btn-manual" expand="block" (click)="confirm()"
    [disabled]="!myPin || (myPin && myPin.length < 4)">{{
    "modal.verify-pin.confirm" | translate }}
  </ion-button>

  <p class="cursor-pointer" (click)="forgetPin()" [innerHtml]="'modal.verify-pin.forgot-pin' | translate"></p>

</ion-content>